import { FirmanteNif, TipoFirma } from '../models/firmante-nif';

/** Codigo del firmante principal (paridad con configuracion de documento estandar). */
export const CODIGO_FIRMANTE_PRINCIPAL = '100';

/** Maximo de firmantes por documento en Envio simple (principal + adicionales). */
export const MAX_FIRMANTES_ENVIO_SIMPLE = 10;

/**
 * Construye un `FirmanteNif` vacio con la forma que esperan
 * `FormularioDocumentoService.setExistingFirmantesNif` / `inicializaFormularioFirma`.
 */
export function construirFirmanteVacio(codigo: string, desc: string): FirmanteNif {
  return {
    tipoFirmante: { codigo, desc },
    nifPage: 0,
    nifOrden: 0,
    nifFormulario: '',
    posicionNif: '',
    firmas: {
      tipoFirma: null as unknown as TipoFirma,
      nombreCertificado: '',
      tieneTag: false,
      nombreTag: '',
      posicionFirmas: []
    },
    formularios: [],
    camposEditables: []
  };
}
